import { create } from 'zustand';

type NotificationDrawerState = {
  /** The bell slide-over. Mounted once at the AppLayout root. */
  open: boolean;
  /**
   * The one notification currently expanded, if any. Only one row is ever open
   * — a list where several rows are expanded stops being scannable, which is
   * the whole point of the compact layout.
   */
  expandedId: string | null;
  openDrawer: () => void;
  /** Open the drawer already focused on one notification (used by the toast). */
  openDrawerWith: (notificationId: string) => void;
  closeDrawer: () => void;
  toggleExpanded: (notificationId: string) => void;
};

// Cross-page overlay state for the notification drawer. Lives in the entities
// layer so both header triggers, the drawer and the toast can read it without a
// widget↔widget import cycle.
export const useNotificationDrawerStore = create<NotificationDrawerState>()(
  (set) => ({
    open: false,
    expandedId: null,
    openDrawer: () => set({ open: true }),
    openDrawerWith: (notificationId) =>
      set({ open: true, expandedId: notificationId }),
    // Collapsing on close keeps the next open predictable rather than
    // restoring a stale expansion from minutes ago.
    closeDrawer: () => set({ open: false, expandedId: null }),
    toggleExpanded: (notificationId) =>
      set((state) => ({
        expandedId: state.expandedId === notificationId ? null : notificationId,
      })),
  })
);
